import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const ClockIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.457 17.014 18.1 15.077V8a1.6 1.6 0 1 0-3.2 0v8c0 .572.305 1.1.8 1.386l4.157 2.4a1.6 1.6 0 1 0 1.6-2.772zM16.5 0C7.663 0 .5 7.163.5 16s7.163 16 16 16 16-7.163 16-16c-.01-8.832-7.168-15.99-16-16zm0 28.8C9.43 28.8 3.7 23.07 3.7 16S9.43 3.2 16.5 3.2 29.3 8.93 29.3 16c-.008 7.066-5.734 12.792-12.8 12.8z"
        fillRule="evenodd"
      />
    </svg>
  )
})
